angular.module('impactx.catalog').controller('CatalogAutomaticApprovalCtrl', [
    '$scope',
    CatalogAutomaticApprovalCtrl]);

function CatalogAutomaticApprovalCtrl($scope) {
    var self = this;
    self.plannedReleaseDate = {};

    self.hours = [];
    for (var i = 0; i < 23; i++) {
        self.hours.push(i);
    }
    self.minutes = [];
    for (var j = 0; j < 60; j = j + 5) {
        self.minutes.push(j);
    }

    $scope.$watch(function () {
                return self.plannedReleaseDate;
            },
            function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (impactX.isDefined($scope, 'formController.plannedReleaseType')) {
                        $scope.dateInPast = !self.checkDateInPast();
                        $scope.formController.plannedReleaseType.$setValidity('invalidReleaseDate', !$scope.dateInPast);
                    }
                }
            }, true
    );

    $scope.$watch(function () {
                return self.plannedReleaseType;
            },
            function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (impactX.isDefined($scope, 'formController.plannedReleaseType')) {
                        $scope.dateInPast = !self.checkDateInPast();
                        $scope.formController.plannedReleaseType.$setValidity('invalidReleaseDate', !$scope.dateInPast);
                    }
                }
            }, true
    );

    $scope.$watch(function () {
            return self.minDate;
        },
        function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (impactX.isDefined($scope, 'formController.plannedReleaseType')) {
                    $scope.dateInPast = !self.checkDateInPast();
                    $scope.formController.plannedReleaseType.$setValidity('invalidReleaseDate', !$scope.dateInPast);
                }
            }
        }, true
    );

    (self.checkDateInPast = function () {
        if (self.plannedReleaseType && self.plannedReleaseType.setId == 2 && self.plannedReleaseDate.dateValue) {
            var currentDate = new Date();
            var currentSetData = new Date(self.plannedReleaseDate.dateValue.getTime());
            currentSetData.setHours(self.plannedReleaseDate.hour);
            currentSetData.setMinutes(self.plannedReleaseDate.minute);
            currentSetData.setSeconds(0);
            currentSetData.setMilliseconds(0);
            if (currentDate.getTime() > currentSetData.getTime()) {
                return false;
            }
            if (self.minDate) {
                var tmpMinDate = new Date(self.minDate.dateValue.getTime());
                tmpMinDate.setHours(self.minDate.hour);
                tmpMinDate.setMinutes(self.minDate.minute);
                tmpMinDate.setSeconds(0);
                tmpMinDate.setMilliseconds(0);
                if (tmpMinDate.getTime() > currentSetData.getTime()) {
                    return false;
                }
            }
        }
        return true;
    })();
}